import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

const firebaseConfig = {
  apiKey: "AIzaSyB4wt-4X7Mhuug6UiQizR8BLCV8UnQAI-w",
  authDomain: "project-4527957683540294270.firebaseapp.com",
  databaseURL: "https://project-4527957683540294270.firebaseio.com",
  projectId: "project-4527957683540294270",
  storageBucket: "project-4527957683540294270.appspot.com",
  messagingSenderId: "203228087391"
}

firebase.initializeApp(firebaseConfig)

export const firebaseApp = firebase
export const firebaseDb = firebase.database
export const uid = () => firebase.auth().currentUser.uid


export const getVersion = (onSuccess) => {
  firebaseDb().ref('utils/version').once('value')
    .then((snapshot) => {
      if (snapshot.exists()) {
        onSuccess(snapshot.val())
      }
    })
    .catch((error) => {
      console.log(error)
    })
}


// WEBPACK FOOTER //
// ./src/Firebase/index.js